var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16",
    height: 16,
    width: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(-1 0 0 -1 17 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10755 10.3333C8.01981 10.3338 7.93283 10.317 7.85161 10.2838C7.77038 10.2506 7.69651 10.2017 7.63421 10.14L4.96755 7.47329C4.90539 7.41113 4.85608 7.33734 4.82244 7.25613C4.7888 7.17491 4.77148 7.08787 4.77148 6.99996C4.77148 6.91205 4.7888 6.82501 4.82244 6.74379C4.85608 6.66258 4.90539 6.58879 4.96755 6.52663C5.0297 6.46447 5.1035 6.41516 5.18471 6.38152C5.26593 6.34788 5.35297 6.33057 5.44088 6.33057C5.52878 6.33057 5.61583 6.34788 5.69705 6.38152C5.77826 6.41516 5.85205 6.46447 5.91421 6.52663L8.10755 8.73329L10.3075 6.61329C10.3689 6.5451 10.4436 6.49029 10.5271 6.4523C10.6106 6.41431 10.701 6.39396 10.7927 6.3925C10.8844 6.39105 10.9754 6.40853 11.06 6.44386C11.1447 6.47919 11.2211 6.5316 11.2846 6.59782C11.348 6.66403 11.3971 6.74263 11.4288 6.82869C11.4605 6.91475 11.4741 7.00643 11.4688 7.09799C11.4634 7.18955 11.4392 7.27901 11.3977 7.3608C11.3562 7.44258 11.2983 7.51492 11.2275 7.57329L8.56088 10.1466C8.43896 10.2642 8.27688 10.3309 8.10755 10.3333Z",
    fill: "#EB564F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBold);
export default __webpack_public_path__ + "static/media/chevron_up_bold.c7b1f4a56204c777b87afd372e6a3ac5.svg";
export { ForwardRef as ReactComponent };